import * as React from 'react';
import type { Control, FieldError, FieldValues, Path, RegisterOptions } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormMessage } from 'shared/ui/form';
import FormControlWithLabel from 'shared/ui/form-control-with-label';
import type { InputProps } from 'shared/ui/input';
import { Input } from 'shared/ui/input';
import type { SkeletonVariant } from 'shared/ui/skeleton';
import { Skeleton } from 'shared/ui/skeleton';
import mergeClasses from 'shared/lib/utils';
interface FormControlInputProps<TData extends FieldValues> extends React.InputHTMLAttributes<HTMLInputElement>, InputProps {
  name: Path<TData>;
  control: Control<TData> | undefined;
  label: string;
  rules?: Omit<RegisterOptions<TData, Path<TData>>, 'disabled' | 'valueAsNumber' | 'valueAsDate' | 'setValueAs'> | undefined;
  error?: FieldError | undefined;
  formItemClassProps?: React.HTMLAttributes<HTMLDivElement>;
}
const FormControlTextField = <TData extends FieldValues,>({
  name,
  control,
  rules,
  error,
  label,
  formItemClassProps,
  ...props
}: FormControlInputProps<TData>) => {
  return <FormField rules={rules} name={name} control={control} render={({
    field
  }) => <FormItem {...formItemClassProps}>
          <FormControlWithLabel text={label}>
            <FormControl>
              <Input {...field} {...props} />
            </FormControl>
          </FormControlWithLabel>
          {error ? <FormMessage>{error.message}</FormMessage> : <FormMessage />}
        </FormItem>} data-sentry-element="FormField" data-sentry-component="FormControlTextField" data-sentry-source-file="form-control-textfield.tsx" />;
};
interface TextFieldSkeletonProps extends SkeletonVariant {
  className?: string;
  divClassName?: string;
}
const TextFieldSkeleton = ({
  variant,
  className,
  divClassName
}: TextFieldSkeletonProps) => {
  return <div className={mergeClasses('grid items-center gap-1', divClassName)} data-sentry-component="TextFieldSkeleton" data-sentry-source-file="form-control-textfield.tsx">
      <span className="py-[5.2px]">
        <Skeleton className="h-3 w-32" variant={variant} data-sentry-element="Skeleton" data-sentry-source-file="form-control-textfield.tsx" />
      </span>
      <Skeleton className={mergeClasses('h-10 w-full', className)} variant={variant} data-sentry-element="Skeleton" data-sentry-source-file="form-control-textfield.tsx" />
    </div>;
};
export { FormControlTextField, TextFieldSkeleton };